import { render, staticRenderFns } from "./LoanInformation.vue?vue&type=template&id=2827eb7f&scoped=true&"
import script from "./LoanInformation.vue?vue&type=script&lang=js&"
export * from "./LoanInformation.vue?vue&type=script&lang=js&"
import style0 from "./LoanInformation.vue?vue&type=style&index=0&id=2827eb7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827eb7f",
  null
  
)

export default component.exports